import { Component, Input } from "@angular/core";

@Component({
    selector: "web-common-shimmer",
    templateUrl: "./common-shimmer.component.html",
    styleUrls: ["./common-shimmer.component.scss"],
})
export class CommonShimmerComponent {
    @Input() height = "10px";
    @Input() width = "100%";
    constructor() {}
}
